document.addEventListener("DOMContentLoaded", function() {
  function handleMobileFooterLinkToggle() {
    if (window.innerWidth <= 768) {
      // Close all other panels
      document.querySelectorAll('.footer-block__heading').forEach(heading => {
        if (heading !== this) {
          heading.classList.remove('active');
          let otherContent = heading.nextElementSibling;
          if (otherContent.style.maxHeight !== '0px') {
            otherContent.style.maxHeight = '0px';
          }
        }
      });
  
      // Toggle the current panel
      let detailsContent = this.nextElementSibling;
      if (this.classList.contains('active')) {
        this.classList.remove('active');
        detailsContent.style.maxHeight = '0px'; // Start the collapsing transition
      } else {
        this.classList.add('active');
        // Set max height to actual scrollHeight plus a little extra space
        detailsContent.style.maxHeight = detailsContent.scrollHeight + "px"; // Expand the panel
      }
    }
  }

  // Announcement dropdown
  var dropdownBtn = document.querySelector('.announcement-dropdown-btn');
  var dropdown = document.querySelector('.announcement-dropdown');
  
  if (dropdownBtn && dropdown) {
    dropdownBtn.addEventListener('click', function() {
      if (dropdown.style.maxHeight && dropdown.style.maxHeight !== '0px') {
        // Collapse the dropdown
        dropdown.style.maxHeight = '0px'; // Start the collapsing transition
      } else {
        // Expand the dropdown
        dropdown.style.maxHeight = dropdown.scrollHeight + 'px'; // Start the expanding transition
      }
      // Toggle the button class
      this.classList.toggle('expanded');
    });

    // Initialize the max-height for transition to work initially
    dropdown.style.maxHeight = '0px';
    dropdown.style.overflow = 'hidden';
    dropdown.style.transition = 'max-height 0.5s ease-in-out';
    dropdown.style.visibility = 'visible';
  }
  
  // Event listener setup
  document.querySelectorAll('.footer-block__heading').forEach(function(heading) {
    heading.addEventListener('click', handleMobileFooterLinkToggle);
  });

  const spinElements = document.querySelectorAll('[image-spin]');
  const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
          if (entry.isIntersecting) {
              entry.target.style.transition = 'transform 1s';
              entry.target.style.transform = 'rotate(360deg)';
              observer.unobserve(entry.target); // Stop observing after animation
          }
      });
  }, { threshold: 0.5 }); // Adjust threshold as needed

  spinElements.forEach(el => {
      observer.observe(el);
  });
  // Define the SVG underline
  const svgUnderline = `
    <svg xmlns="http://www.w3.org/2000/svg" width="100" height="10" viewBox="0 0 100 10" aria-hidden="true" focusable="false" class="svg-underline">
      <path d="M0 8 Q50 2, 100 8" fill="none" stroke="black" stroke-width="3"></path>
    </svg>
  `;

  // Select all headings (h1 to h6)
  const headings = document.querySelectorAll("h1, h2, h3, h4, h5, h6");

  // Loop through each heading
  headings.forEach(heading => {
    // Convert textContent to lowercase for case-insensitive check
    if (heading.textContent.toLowerCase().includes("true")) {
      // Use a case-insensitive regex to replace "true" in any case
      const updatedHTML = heading.innerHTML.replace(
        /\b(true)\b/gi, // Match the word "true" (case-insensitive)
        `<span class="underlined-word">$1${svgUnderline}</span>`
      );
      heading.innerHTML = updatedHTML;
    }
  });

  // Show read more description
  const readMoreButton = document.querySelector(".product-description__read-more");
  const descShort = document.querySelector(".product-description-short");
  const descLong = document.querySelector(".product-description-full");
  const fade = document.querySelector(".product-description__fade");
  if (readMoreButton) {
    readMoreButton.addEventListener("click", () => {
      readMoreButton.style.display = "none";
      descShort.style.display = "none";
      fade.style.display = "none";
      descLong.style.display = "block";
    });
  }
});
